import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthorizationService} from '../../services/authorization.service';
import {MainHubService} from '../../services/main-hub.service';

import {MenuItem, PrimeIcons} from 'primeng/api';


@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.css']
})
export class NavMenuComponent implements OnInit {

  isExpanded = false;

  constructor(public authorizationService: AuthorizationService, public router: Router, public mainHubeService: MainHubService) {
    mainHubeService.needAmeritradeLogin.subscribe(val => {
      console.log('chan', val);
    });
  }
  ngOnInit(): void {

  }



  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  login() {
    this.router.navigate(["login"]);
  }

  loginToAmeritrade() {
    this.mainHubeService.loginToAmeritrade();
  }

  logout() {
    this.authorizationService.removeToken();
    this.router.navigate(['login']);
  }
}
